import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .MuiDialogContent-root {\n    padding: 0 28px;\n  }\n\n  .MuiPaper-root {\n    width: 520px;\n\n    max-height: calc(100vh - 144px);\n    margin: 72px 0;\n    border-radius: 12px;\n    @media (max-width: 768px) {\n      padding: 20px !important;\n    }\n  }\n\n  .MuiDialogActions-root {\n    padding: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  height: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px; /* 150% */\n  color: ",
        ";\n\n  margin-bottom: 8px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import styled from "styled-components";
import Icon from "../icon/Icon";
import { Close, Sizes } from "../icon/IconList";
const SimpleDialog = (param)=>{
    let { open , onClose , children , footer , scroll , subParagraph , title , ...props } = param;
    return /*#__PURE__*/ _jsxs(DialogContainer, {
        open: open,
        onClose: onClose,
        scroll: scroll,
        ...props,
        sx: {
            h2: {
                padding: "28px"
            }
        },
        children: [
            /*#__PURE__*/ _jsxs(DialogTitle, {
                id: "scroll-dialog-title",
                children: [
                    /*#__PURE__*/ _jsxs(DialogHeader, {
                        children: [
                            title,
                            /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": "close",
                                onClick: (e)=>onClose(e, "backdropClick"),
                                sx: (theme)=>({
                                        height: "fit-contents",
                                        padding: "4px",
                                        ":hover": {
                                            background: "none"
                                        }
                                    }),
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    icon: Close,
                                    size: Sizes.medium
                                })
                            })
                        ]
                    }),
                    // subParagraph이 string일 경우에만 ExplainText로 감싸줌
                    // subParagraph이 ReactNode일 경우에는 그대로 렌더링
                    typeof subParagraph === "string" ? /*#__PURE__*/ _jsx(ExplainText, {
                        children: subParagraph
                    }) : subParagraph
                ]
            }),
            /*#__PURE__*/ _jsx(DialogContent, {
                children: /*#__PURE__*/ _jsx(ContentBox, {
                    children: children
                })
            }),
            /*#__PURE__*/ _jsx(DialogActions, {
                children: footer
            })
        ]
    });
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(DialogHeader, {
        children: children
    });
};
SimpleDialog.Title = Title;
const DialogContainer = styled(Dialog).withConfig({
    componentId: "sc-6eacd2c1-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_dim_white_90);
const ContentBox = styled.section.withConfig({
    componentId: "sc-6eacd2c1-1"
})(_templateObject1());
const ExplainText = styled.p.withConfig({
    componentId: "sc-6eacd2c1-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_700);
const DialogHeader = styled.div.withConfig({
    componentId: "sc-6eacd2c1-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_900);
export default SimpleDialog;
